module.exports = __webpack_public_path__ + "img/pin-2000.e0874567.png";